import { useAppSelector } from '../../../../../reduxService/hooks';
import { EProjectType } from '../../../../enum/project';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import HydraulicSloped from './HydraulicSloped';
import HydraulicStepped from './HydraulicStepped';
import HydraulicVertical from './HydraulicVertical';

interface IHydraulicResultsProps {}

const HydraulicResults = (props: IHydraulicResultsProps) => {
    const projectInfo = useAppSelector(selectProjectInfo);

    let canvas: JSX.Element;

    switch (projectInfo.data!.type) {
        case EProjectType.Macra2 | EProjectType.VerticalDrop:
            canvas = <HydraulicVertical />;
            break;
        case EProjectType.Macra2 | EProjectType.SlopedWeir:
            canvas = <HydraulicSloped />;
            break;
        case EProjectType.Macra2 | EProjectType.SteppedWeir:
            canvas = <HydraulicStepped />;
            break;
        default:
            canvas = <></>;
            break;
    }

    return canvas;
};

export default HydraulicResults;
